import ReactGA from "react-ga4";

export const initAnalytics = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.initialize("G-XNGKWK0501", { debug: true });
};

export const isAnalyticsEnabled = () => {
  return localStorage.getItem("cookie_consent") === "accepted";
}

export const trackPageView = (path) => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.send({ hitType: "pageview", page: path });
};

export const trackRegistrationEvent = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.event({
    category: "user",
    action: "user registration",
    label: "register",
    value: 1,
  });
};

export const trackOrderCreatedEvent = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.event({
    category: "order",
    action: "order created",
    label: "orderCreated",
    value: 1,
  });
};

export const trackSendingMessageEvent = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.event({
    category: "message",
    action: "sending message",
    label: "sendingMessage",
    value: 1,
  });
};

export const trackDownloadQREvent = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.event({
    category: "qr",
    action: "download qr",
    label: "downloadQr",
    value: 1,
  });
};

export const trackEnablePushNotificationsEvent = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.event({
    category: "settings",
    action: "push notifications on",
    label: "pushNotificationsOn",
    value: 1,
  });
};

export const trackEnableEmailNotificationsEvent = () => {
  if (!isAnalyticsEnabled()) { return; }
  ReactGA.event({
    category: "settings",
    action: "email notifications on",
    label: "emailNotificationsOn",
    value: 1,
  });
};